import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m323-488 210 23 16-34-61-33-93-8 6-79 111 8 221 123q17 10 35.5 12.5T802-484L606-680H357l-65-96-110 55 76 183q8 21 25.5 34t39.5 16m-9 79q-44-5-78.5-31T184-507L80-760l240-120 80 120h208q16 0 31 6.5t26 17.5l255 256-34 34q-38 38-91 45.5T695-419l-76-41-13 29q-11 23-33 35.5t-48 9.5zM130-121l-22-77 190-50q72-19 153-35.5T599-300q75 0 139.5 30T866-189l-54 59q-51-43-105.5-66.5T599-220q-64 0-141 16.5T319-171z"
    }, null, -1)
  ]))]))
}
export default { render: render }